<template>
  <!-- 抽屉 -->
  <a-drawer
    :visible="visible"
    title="材料定价管理"
    width="60%"
    :destroy-on-close="false"
    :mask-closable="false"
    @close="close"
  >
    <!-- 抽屉内完全沿用原页面结构 -->
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option :value="1">启用</a-select-option>
                  <a-select-option :value="0">禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="定价类型">
                <a-select placeholder="请选择" v-model="queryParam.pricingType" style="width: 100%" allow-clear>
                  <a-select-option :value="1">固定</a-select-option>
                  <a-select-option :value="0">自定义</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"> <a-icon type="search" />查询 </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"> <a-icon type="redo" />重置 </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作 -->
      <div class="table-operations">
        <template v-if="isOperate">
          <a-button
            type="primary"
            @click="$refs.createForm.handleAdd(queryParam.prodSkuId)"
            v-hasPermi="['upkeep:prod-sku-material-item:add']"
          >
            <a-icon type="plus" />新增
          </a-button>
          <!-- <a-button
            type="primary"
            :disabled="single"
            @click="$refs.createForm.handleUpdate(undefined, ids)"
            v-hasPermi="['upkeep:prod-sku-material-item:add']"
          >
            <a-icon type="edit" />修改
          </a-button> -->
          <a-button
            type="danger"
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['upkeep:prod-sku-material-item:remove']"
          >
            <a-icon type="delete" />删除
          </a-button>
        </template>

        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>

      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :userList="userList"
        :statusOptions="dict.type['sys_enable_disable']"
        @ok="getList"
      />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="materialItemId"
        :columns="columns"
        :data-source="list"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="status" slot-scope="text, record">
          <a-tag :color="record.status === 1 ? 'green' : 'red'">
            {{ record.status === 1 ? '启用' : '禁用' }}
          </a-tag>
        </span>

        <span slot="pricingType" slot-scope="text, record">
          <span v-if="record.pricingType == 0"> 固定价格{{ record.price }} </span>
          <span v-else> 最小定价{{ record.priceMin }}-最高定价{{ record.priceMax }} </span>
        </span>

        <span slot="operation" slot-scope="text, record">
          <!-- <a @click="edit(record)" v-hasPermi="['upkeep:prod-sku-material-item:add']"> 修改 </a> -->
          <!-- <a-divider type="vertical" v-hasPermi="['upkeep:prod-sku-material-item:remove']" /> -->
          <a @click="handleDelete(record)" v-hasPermi="['upkeep:prod-sku-material-item:remove']"> 删除 </a>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </a-drawer>
</template>

<script>
import { fetchList, delObj, statusObj } from '@/api/maintenance/materialPricing/index'
import CreateForm from '../../materialPricing/modules/CreateForm.vue'
import { tableMixin } from '@/store/table-mixin'
import { listTenant } from '@/api/system/tenant'
import { mapGetters } from 'vuex'
import { edit } from '@/api/pay/merchants'

export default {
  name: 'MaterialPricingDrawer',
  components: { CreateForm },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    tenantFirmId: {
      type: [String, Number],
    },
    tenantId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      prodSkuId: undefined,
      visible: false,
      list: [],
      userList: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        keyword: undefined,
        periodType: undefined,
        searchCount: undefined,
        tenantFirmId: this.tenantFirmId,
        tenantId: this.tenantId,
        prodSkuId: undefined,
      },
      columns: [
        // {
        //   title: 'id',
        //   dataIndex: 'prodSkuId',
        //   align: 'center',
        // },
        {
          title: '服务标识',
          dataIndex: 'materialItemName',
          align: 'center',
        },
        {
          title: '定价',
          dataIndex: 'pricingType',
          ellipsis: true,
          scopedSlots: { customRender: 'pricingType' },
          align: 'center',
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    edit(row) {
      const record = { ...row, prodSkuId: this.queryParam.prodSkuId }
      this.$refs.createForm.handleUpdate(record, undefined)
    } /* 对外命令式打开 */,
    open(row) {
      this.visible = true
      this.queryParam.prodSkuId = row.id
      this.prodSkuId = row.id
      this.getList()
      if (!this.tenantFirmId) this.getQi()
    },
    /* 对外命令式关闭 */
    close() {
      this.visible = false
      this.selectedRowKeys = []
      this.selectedRows = []
      this.ids = []
      this.single = true
      this.multiple = true
    },

    handleStatusType(row, newStatus) {
      statusObj({ prodSkuId: row.prodSkuId, serviceItemId: row.serviceItemId })
        .then(() => {
          this.$message.success('操作成功！')
          this.getList()
        })
        .catch(() => {
          row.status = row.status === 0 ? 1 : 0
        })
    },
    getQi() {
      const query = { pageNum: 1, pageSize: 999, type: 1, status: 0 }
      listTenant(query).then((res) => {
        this.userList = res.data.records
      })
    },
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
        tenantFirmId: this.tenantFirmId,
        tenantId: this.tenantId,
        prodSkuId: this.queryParam.prodSkuId,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.materialItemId || this.ids || []
      if (row.materialItemId) {
        ids = [{ prodSkuId: row.prodSkuId, materialItemId: row.materialItemId }]
      } else {
        postIds.forEach((v) => {
          ids.push({ materialItemId: v.materialItemId, prodSkuId: v.prodSkuId })
        })
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    handleExport() {
      const that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('fix/dev/export', { ...that.queryParam }, `设备信息${new Date().getTime()}.xlsx`)
        },
        onCancel() {},
      })
    },
  },
}
</script>
